/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";
import { DOMAIN} from "./Config";
import { Toast } from "antd-mobile";
const CancelToken = axios.CancelToken;
console.log(DOMAIN)
const request = async (uri, { method = "POST", data, header = {} }) => {
  const headers={
    "Content-Type": "application/json",
    ...header,
    'access-token':localStorage.getItem("access-token")||"",
  };
  
  if(window.cancleList[uri]){
    window.cancleList[`${uri}`]();
    await new Promise((resolve, reject) => {
      setTimeout(() =>{
        resolve(1)
      },5)
    })
  }
  const moredata = new URL(window.location.href).searchParams.toString();
  uri += uri.indexOf("?") > 0 ? `&${moredata}` : `?${moredata}`;
  const requestOptions = {
    url: DOMAIN + uri,
    method,
    headers,
    withCredentials: true,
    cancelToken: new CancelToken(c => {
      // 调用c就可以取消此请求
      window.cancleList[uri]=c;
    }),
    validateStatus: (status) => status >= 200 && status <= 401,
  };
  if (method === "POST") {
    requestOptions.data = JSON.stringify(data);
  }
  return axios(requestOptions)
    .then(({ data}) => {
      delete window.cancleList[uri];
      if (data.result === "success") {
        if(data.message==="auth require"){
           window.location.replace(data.data.redirect);
          return;
        }
        return { data };
      } 
        if (data.result === "redirect") {
          window.location.replace(data.data);
          return;
        }
        if (data.result === "autherror") {
          return;
        }
        if ( data.result === "error") {
           Toast.show(data.message || "请求失败，请重试!");
           return;
        }
        Toast.show(data.message || "请求失败，请重试!");
        return { err: data.message };
      
    })
    .catch((err) =>{
      delete window.cancleList[uri];
      return { err }
    });
};

export default request;